<template lang="pug">
  div
    p Result :
      br
      b(v-if="url") Link : {{ url }}
      //- v-btn(v-if='url' :href='url' target='_blank' color='success') Click Here
    qrcode-stream(@decode="onDecode" @init="$emit('init', $event)")
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
// import { getTanggal, decrypt } from "../utils/data";
import { mapState } from "vuex";
// import axios from "axios";
export default {
  components: { QrcodeStream },
  data () {
    return {
      imNo: null,
      imType: null,
      url: null,
      result: null
    }
  },
  computed: {
    ...mapState(["API_URL"])
  },
  methods: {
    async onDecode (result) {
      // let data = JSON.parse(decrypt(result));
      // this.imNo = data[0];
      // this.imType = data[1];
      // let link = `${this.API_URL}/qr/linkpreview/${this.imNo}/${this.imType}`;
      // const config = {
      //   method: "get",
      //   url: `${this.API_URL}/qr/linkpreview/${this.imNo}/${this.imType}`,
      //   headers: {"Authorization": `Bearer ${this.$store.state.token}`}
      // };
      // let rs = await axios(config);
      // this.url = rs.data ? rs.data : null;
      this.url = result;
    }
  }
}
</script>
